import { ONBOARDING_RESOURCE_CATEGORIES, type OnboardingResourceCategory } from "@shared/schema";

export const CATEGORY_LABELS: Record<OnboardingResourceCategory, string> = {
  sobre_a_comp: "Sobre a Comp",
  dia_a_dia: "Dia a Dia",
  ferramentas: "Ferramentas",
  politicas: "Políticas",
  cliente: "Cliente",
  produto: "Produto",
  engenharia: "Engenharia",
};

export const CATEGORY_OPTIONS = ONBOARDING_RESOURCE_CATEGORIES.map((c) => ({
  value: c,
  label: CATEGORY_LABELS[c],
}));
